import React from "react";
import { Alert, Button, Space, Typography } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const { Paragraph } = Typography;

const download = (codes: string[]) => {
	if (typeof URL.createObjectURL !== "function") return;
	const url = URL.createObjectURL(new Blob([`${codes.join("\n")}\n`], { type: "text/plain" }));
	const link = document.createElement("a");
	link.href = url;
	link.download = "recovery-codes.txt";
	link.click();
	URL.revokeObjectURL(url);
};

// Shown once: identity stores only their hashes (contract §6.6).
const RecoveryCodesList: React.FC<{ codes: string[] }> = ({ codes }) => (
	<div data-testid="security-recovery-codes">
		<Alert
			type="warning"
			showIcon
			message="Save these recovery codes now"
			description="Each code works once if you lose your authenticator app or passkey. They will not be shown again."
			style={{ marginBottom: "var(--mg-sp-6)" }}
		/>
		<ol className="security-recovery-codes" aria-label="Recovery codes">
			{codes.map((code) => (
				<li key={code} data-testid="security-recovery-code">
					{code}
				</li>
			))}
		</ol>
		<Space wrap>
			<Paragraph copyable={{ text: codes.join("\n"), tooltips: ["Copy codes", "Copied"] }} style={{ marginBottom: 0 }}>
				Copy all
			</Paragraph>
			<Button size="small" icon={<DownloadOutlined />} onClick={() => download(codes)}>
				Download
			</Button>
		</Space>
	</div>
);

export default RecoveryCodesList;
